import { useEntityPanelManager } from './entity-panel-manager';
import { useWorkspaceStore } from '../../../use-workspace-store';
import { getEntityPanelSortComparator, getHistoricalPanelSortComparator } from '../utils';

export const useOpenBoloPanels = (searchText: string) => {
    const entityPanelManager = useEntityPanelManager();
    const boloPanels = entityPanelManager.boloPanelList;
    const workspacePanelsStore = useWorkspaceStore();

    const allBoloWorkspacePanels = workspacePanelsStore.activePanels.filter(
        (panel) => panel.workspacePanelType === 'BOLO'
    );

    const getHash = (boloNumber?: string, boloType?: string) => {
        return [boloNumber, boloType]
            .filter((x) => !!x)
            .join('~')
            .toLowerCase();
    };

    const filteredBoloPanels = boloPanels
        .filter((boloPanel) => {
            if (!searchText) return true;
            const formattedSearchText = searchText.trim().toLowerCase();
            return (
                getHash(
                    boloPanel.metadata.boloNumber,
                    boloPanel.form.getValues('boloType.label')
                ).indexOf(formattedSearchText) !== -1
            );
        })
        .sort(getEntityPanelSortComparator);

    const historicalBoloPanels = entityPanelManager.historicalBoloPanelsList;

    const filteredRecentBoloPanels = historicalBoloPanels
        .filter((historicalBoloData) => {
            if (!searchText) return true;
            if (
                allBoloWorkspacePanels.some(
                    (panel) => panel.linkedEntityId === historicalBoloData.boloId
                )
            ) {
                return false;
            }
            const formattedSearchText = searchText.trim().toLowerCase();
            return (
                getHash(historicalBoloData.boloNumber, historicalBoloData.boloType).indexOf(
                    formattedSearchText
                ) !== -1
            );
        })
        .sort(getHistoricalPanelSortComparator)
        .slice(0, 20);

    return {
        filteredBoloPanels,
        filteredRecentBoloPanels,
        allBoloWorkspacePanels,
    };
};
